import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroSessao extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';

    get label() {
        return 'Sessão';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        return registro.sessaoId;
    }

    getDescricao(valor) {
        const sessaoSelecionada = this.store.rootStore.sessaoStore.sessaoSelecionada;
        if (!sessaoSelecionada) {
            console.warn(
                `Não há registro de sessão selecionada para viabilizar a aplicação do filtro de sessão [valor procurado: ${valor}]`
            );
            return '';
        }

        if (!sessaoSelecionada.sessoes) {
            console.warn(
                `Não há uma lista de sessões como propriedade da sessão selecionada [valor procurado: ${valor}]`
            );
            return '';
        }

        const sessao = sessaoSelecionada.sessoes.find((sessao) => sessao.id === valor);
        if (!sessao) {
            console.log(sessaoSelecionada);
            console.warn(
                `Não foi possível encontrar a sessão na lista de sessões da sessão selecionada "sessaoSelecionada.sessoes". valor procurado: ${valor}]`
            );
            return '';
        }

        if (!sessao.descricao) {
            console.warn(`Não há uma descrição definida para a sessão "${sessao}" [valor procurado: ${valor}]`);
            return '';
        }

        return sessao.descricao;
    }
}
